module.exports = __webpack_public_path__ + "img/bannerOrange.ed5b225d.jpg";